import SubscriptionBillings from '@/models/loyaltyPanel/subscriptions/SubscriptionBillings';
const getDefaultState = () => ({
  billings: [],
  billingsPagination: {},
});

export default {
  namespaced: true,
  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setBillings(state, payload) {
      state.billings = payload;
    },
    setBillingsPagination(state, payload) {
      state.billingsPagination = payload;
    },
  },

  actions: {
    async updateStatus({ commit }, payload) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await SubscriptionBillings.updateStatus(payload);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message || ex,
          },

          { root: true }
        );
      }
    },

    async notifyBilling({ commit }, payload) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await SubscriptionBillings.notifyBilling(payload);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message || ex,
          },

          { root: true }
        );
        return ex.response.data;
      }
    },

    async getBillings({ commit }, { id, page }) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await SubscriptionBillings.getBillings(id, page);
        commit('setLoading', false, { root: true });
        commit('setBillings', data.data.billings);
        commit('setBillingsPagination', data.data.pagination);
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message || ex,
          },

          { root: true }
        );
        return ex.response.data;
      }
    },

    async cancelBilling({ dispatch, commit }, billing) {
      try {
        console.log(billing, 'billing in cancelBilling action');
        commit('setLoading', true, { root: true });
        const { data } = await SubscriptionBillings.cancelBilling(billing.billing_id);

        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        console.error('Error canceling billing:', ex);
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
